if (!customElements.get('team-info-showcase')) {
  customElements.define(
    'team-info-showcase',
    class extends HTMLElement {
      connectedCallback() {
        this.thumbs = this.querySelectorAll('[data-member-thumb]');
        this.panels = this.querySelectorAll('[data-member-panel]');

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const id = thumb.dataset.memberId;

            this.thumbs.forEach(t => t.classList.remove('is-active'));
            thumb.classList.add('is-active');

            this.panels.forEach(panel => {
              panel.hidden = panel.dataset.memberPanel !== id;
              panel.classList.toggle('is-active', panel.dataset.memberPanel === id);
            });

            const activePanel = this.querySelector(`[data-member-panel="${id}"]`);
            const bio = activePanel?.querySelector('.team-info-panel__bio-scroll');
            if (bio) bio.scrollTop = 0;
          });
        });
      }
    }
  );
}